import AppPageMetadata from "@richbeauty/core/AppPageMetadata";
import AppsContainer from "@richbeauty/core/AppsContainer";
import AppsContent from "@richbeauty/core/AppsContainer/AppsContent";
import AppsHeader from "@richbeauty/core/AppsContainer/AppsHeader";
import useAppShowHideTableColumn from "hooks/UseAppShowHideTableColumn";
import { useIntl } from "react-intl";
import useGetCustomerLeadColumn from "./useGetCustomerLeadColumn";
import "./index.style.less";
import AppButtonActions from "../../../@richbeauty/core/AppButtonAction";

import { downLoadFileFromResponse } from "@richbeauty/utility/Utils";
import { useCallback, useRef, useState } from "react";
import useAppConfirmModal from "hooks/useAppConfirmModal";
import IntlMessages from "../../../@richbeauty/utility/IntlMessages";
import { Pagination } from "antd";
import { revalidateCustomerLeads } from "@richbeauty/utility/helper/cacheRevalidator";
import AppTableContainer from "@richbeauty/core/AppTableContainer";
// import useGetLeads from "hooks/apis/leads/useGetLeads";
import { PageDefault, TakeDefault } from "shared/constants/AppConst";
import CustomerLeadTableSearch from "./CustomerLeadTableSearch";
import AppCustomModalWrapper from "@richbeauty/core/AppCustomModalWrapper";
import CreateCustomerLeadModal from "./CreateAndEditLeadModal/CreateCustomerLeadModal";
import toast from "react-hot-toast";
import { PERMISSIONS } from "shared/constants/AppEnums";
import useGetCustomerLeads from "hooks/apis/customerLeads/useGetCustomerLeads";
import useDeleteCustomerLeads from "hooks/apis/customerLeads/useDeleteCustomerLeads";
import { downloadCustomerLeadsTemplate } from "hooks/apis/customerLeads/useCustomerLeadDownloadTemplate";
import { exportCustomerLeadFile } from "hooks/apis/customerLeads/useCustomerLeadExport";
import ImportCustomerLeadModal from "./ImportCustomerLeadModal";

const CUSTOMER_LEAD_TABLE_KEY = "CustomerLeadTable";
const CustomerLeads = () => {
  const { formatMessage, messages } = useIntl();
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const createCustomerLeadModalRef = useRef();
  const customerCustomerLeadColumns = useGetCustomerLeadColumn();
  const { contextHolder: contextConfirmDelete, openModal: openConfirmDelete } =
    useAppConfirmModal();
  const { filteredTableColumns, tableColumnDisplayConfigurator } =
    useAppShowHideTableColumn({
      tableKey: CUSTOMER_LEAD_TABLE_KEY,
      tableColumns: customerCustomerLeadColumns,
    });
  const { trigger: triggerDeleteCustomerLeads } = useDeleteCustomerLeads();
  const onDelete = useCallback(() => {
    openConfirmDelete({
      title: <IntlMessages id="app.quotes.deleteQuote" />,
      okText: <IntlMessages id="common.save" />,
      cancelText: <IntlMessages id="common.cancel" />,
      onOk: () => {
        triggerDeleteCustomerLeads(selectedRowIds, {
          onSuccess: async (data) => {
            revalidateCustomerLeads();
            setSelectedRowIds([]);
            toast.success(data?.message);
          },
          onError: (error) => {
            toast.error(error?.message);
          },
        });
      },
    });
  }, [openConfirmDelete, selectedRowIds, triggerDeleteCustomerLeads]);
  const [params, setParams] = useState({
    page: PageDefault,
    take: TakeDefault,
    freeText: "",
    stateId: "",
    statusFilter: undefined,
  });
  const { data: customerLeadsData, isLoading: isLoadingCustomerLeadsData } =
    useGetCustomerLeads(params);

  const handleTableSearchChange = (_changed, all) => {
    setParams((prev) => ({
      ...prev,
      search: all.search || "",
      stateId: all.stateId || "",
      statusFilter: all.statusFilter,
      page: PageDefault,
    }));
  };
  const importCustomerLeadModalRef = useRef();

  const handleDownloadTemplate = async () => {
    const res = await downloadCustomerLeadsTemplate();
    downLoadFileFromResponse(res, "customer_lead_template");
  };
  const handleExport = async () => {
    const res = await exportCustomerLeadFile(params);
    downLoadFileFromResponse(res, "customer_leads_export");
  };

  return (
    <>
      <AppPageMetadata
        title={formatMessage({ id: "sidebar.crm.customerLeads" })}
      />
      <AppsContainer
        fullView
        type="bottom"
        title={formatMessage({ id: "sidebar.crm.customerLeads" })}
        headerRightElement={
          <div className="page-header-right">
            <AppButtonActions
              style={{ backgroundColor: "orange", border: "none" }}
              scopes={[PERMISSIONS.IMPORT_CUSTOMER_LEAD]}
              title={
                messages["common.downloadTemplate"]?.toString?.() ||
                "Download Template"
              }
              onClick={handleDownloadTemplate}
            />
            <AppButtonActions
              style={{ backgroundColor: "#1890ff", border: "none" }}
              scopes={[PERMISSIONS.IMPORT_CUSTOMER_LEAD]}
              title={messages["common.export"]?.toString?.() || "Export"}
              onClick={handleExport}
            />
            <AppButtonActions
              style={{ backgroundColor: "green", border: "none" }}
              scopes={[PERMISSIONS.IMPORT_CUSTOMER_LEAD]}
              title={messages["common.import"]}
              onClick={() => importCustomerLeadModalRef.current?.openModal()}
            />
            {tableColumnDisplayConfigurator}
          </div>
        }
      >
        <AppsHeader>
          <div className="page-header">
            <div className="page-header-input-view" style={{ width: "100%" }}>
              <CustomerLeadTableSearch
                onValuesChange={handleTableSearchChange}
              />
            </div>
            <div className="page-header-right">
              <AppButtonActions
                scopes={[PERMISSIONS.CREATE_CUSTOMER_LEAD]}
                title={messages["app.customerLeads.createCustomerLead"]}
                type="primary"
                onClick={() => createCustomerLeadModalRef.current?.openModal()}
              />
              <AppButtonActions
                scopes={[PERMISSIONS.DELETE_CUSTOMER_LEAD]}
                title={formatMessage({
                  id: "app.customerLeads.deleteCustomerLead",
                })}
                disabled={!selectedRowIds.length}
                onClick={onDelete}
                type="danger"
              />
            </div>
          </div>
        </AppsHeader>
        <AppsContent>
          <AppTableContainer
            data={customerLeadsData?.data}
            columns={filteredTableColumns}
            rowSelection={{
              type: "checkbox",
              onChange: (_, selectedRows) =>
                setSelectedRowIds(selectedRows?.map((row) => row?.id)),
            }}
            loading={isLoadingCustomerLeadsData}
          />
        </AppsContent>
        <div className="custom-pagination">
          <Pagination
            current={params.page}
            onChange={(page, pageSize) =>
              setParams((prev) => ({ ...prev, page: page, take: pageSize }))
            }
            total={customerLeadsData?.meta?.totalCount}
            showTotal={(total, range) => (
              <p>
                {range[0]}-{range[1]} {String(messages["common.on"])} {total}{" "}
                records
              </p>
            )}
            showSizeChanger
          />
        </div>
        <AppCustomModalWrapper ref={createCustomerLeadModalRef}>
          <CreateCustomerLeadModal />
        </AppCustomModalWrapper>
        <AppCustomModalWrapper ref={importCustomerLeadModalRef}>
          <ImportCustomerLeadModal />
        </AppCustomModalWrapper>
      </AppsContainer>
      {contextConfirmDelete}
    </>
  );
};

export default CustomerLeads;
